import { makeStyles } from '@mui/styles'

// FIXME Mezclar estos estilos conforme al nuevo formato, como el objeto de abajo
export const useStyles = makeStyles(theme => ({
  // MAIN CONTENT
  root: {
    position: 'relative',
  },

  modalContainer: {
    minHeight: 380,
  },

  title: {
    marginBottom: theme.spacing(3),
  },

  searchInput: {
    width: theme.spacing(40),
  },

  csvButton: {
    padding: 'revert',
    marginLeft: theme.spacing(1),
  },

  rowHeader: {
    flex: 10,
    display: 'flex',
    flexDirection: 'row',
  },

  centerSelect: {
    marginBottom: theme.spacing(2),
    width: theme.spacing(40),
    marginRight: theme.spacing(1),
  },

  rowButtons: {
    marginLeft: 'auto',
    //flex: 3,
    width: 'fit-content',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    marginBottom: theme.spacing(3),
    marginTop: theme.spacing(4.25),
  },

  '@media screen and (max-width: 1450px)': {
    rowButtons: {
      marginLeft: 0,
    },
  },

  rowInputs: {
    //flex: 3,
    flexWrap: 'wrap',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    marginBottom: theme.spacing(3),
    marginRight: theme.spacing(1),
  },

  textHeader: {
    flex: 7,
  },

  actionButtons: {
    marginInline: '12px',
    cursor: 'pointer',
  },

  actionButton: {
    marginLeft: '10px',
  },

  pointer: {
    cursor: 'pointer',
  },

  paragraphText: {
    marginBottom: theme.spacing(2),
  },

  pickUpContent: {
    height: 200,
    marginBottom: theme.spacing(2),
    marginTop: theme.spacing(2),
  },

  /////////////////////
  column: {
    display: 'flex',
    flexDirection: 'column',
  },

  row: {
    display: 'flex',
    flexDirection: 'row',
  },

  subtitle: {
    marginBottom: theme.spacing(4),
    color: theme.palette.neutral.main,
  },

  primaryText: {
    color: theme.palette.primary.main,
    fontWeight: 'bold',
  },

  secondaryText: {
    color: theme.palette.neutral.main,
  },

  stepText: {
    flex: 0.5,
  },

  pointStep: {
    color: theme.palette.primary.main,
    height: '22px',
    width: '22px',
    display: 'inline-flex',
    justifyContent: 'center',
    alignItems: 'center',
    borderRadius: '50%',
    backgroundColor: theme.palette.primary.lightest,
    marginRight: theme.spacing(1),
  },

  emptyState: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    rowGap: theme.spacing(3),
    padding: theme.spacing(10, 2),
    height: '60vh',
  },

  paper: {
    marginBottom: theme.spacing(4),
  },

  modalContent: {
    display: 'flex',
    flex: 10,
  },

  uploaderContent: {
    flex: 7,
  },

  instructionsContent: {
    display: 'flex',
    flexDirection: 'column',
    padding: theme.spacing(0, 3, 0, 3),
    flex: 3,
  },

  buttonsGroup: {
    display: 'flex',
    width: '100%',
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
    justifyContent: 'end',
    alignContent: 'flex-end',
    marginLeft: 'auto',
  },

  cancelButton: {
    marginRight: theme.spacing(1),
  },

  marginInput: {
    marginRight: 10,
  },

  mainContainer: {
    maxWidth: 850,
  },
  section: {
    padding: theme.spacing(4, 0),
  },
  shippingInput: {
    maxWidth: 390,
  },

  // SUMMARY
  summary: {
    backgroundColor: theme.palette.neutral.lightest,
    padding: theme.spacing(6.5, 0),
  },
  summaryLabel: {
    marginBottom: theme.spacing(1),
    color: theme.palette.neutral.main,
  },
  summaryNumber: {
    marginBottom: theme.spacing(3.5),
    color: theme.palette.neutral.dark,
  },

  // ACTIONS
  actions: {
    display: 'flex',
    alignItems: 'flex-start',
    marginBottom: theme.spacing(2),
  },

  actionsSelect: {
    width: theme.spacing(20),
    '& .MuiInput-root': {
      marginTop: 0,
    },
    '& .MuiFormHelperText-root': {
      display: 'none',
    },
  },

  actionsInput: {
    minWidth: theme.spacing(36),
    marginRight: theme.spacing(3),
  },

  actionsLastButton: {
    marginLeft: 'auto',
  },
}))

const styles = {
  alert: {
    width: '100%',
    maxWidth: 400,
    borderRadius: theme => theme.spacing(0.5),

    '& .MuiButton-root': {
      margin: theme => theme.spacing(1.75, 'auto', 0, 0),
    },
  },
  alertError: {
    marginTop: theme => theme.spacing(3),
    marginLeft: 'auto',
  },
  tableContainer: {
    marginTop: theme => theme.spacing(4),
    maxHeight: 350,
    overflowY: 'auto',
  },
  tableHead: {
    position: 'sticky',
    top: 0,
    backgroundColor: theme => theme.palette.neutral.white,
  },
}

export default styles
